import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  body: {
    paddingLeft: theme.spacing() * 2,
    paddingRight: theme.spacing() * 2,
    paddingBottom: theme.spacing() * 3,
    margin: "0 auto",
    backgroundColor: "#ffffff",
    width: "80vw",
    [theme.breakpoints.down("sm")]: {
      width: "100% !important",
    },
    "& > *": {
      opacity: 0,
    },
  },
  footer: {
    textAlign: "center",
    position: "relative",
    margin: "0 auto",
    backgroundColor: "#ffffff",
    width: "80vw",
    [theme.breakpoints.down("sm")]: {
      width: "100% !important",
    },
    "& > *": {
      opacity: 0,
    },
  },
  footerContent: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  visible: {
    "& > *": {
      opacity: 1,
      transition: "opacity 900ms",
    },
  },
}));

export default (appBarHeight, footerHeight) =>
  withRouter(({ children, location: { pathname } }) => {
    const classes = useStyles();
    const [localPathname, setLocalPathname] = useState(null);
    const visible = localPathname === pathname;

    useEffect(() => {
      if (localPathname !== pathname) {
        setTimeout(() => {
          setLocalPathname(pathname);
        }, 1);
      }
    }, [localPathname, pathname]);

    return (
      <>
        <div
          className={[classes.body, visible ? classes.visible : ""]
            .join(" ")
            .trim()}
          style={{
            marginTop: appBarHeight,
            minHeight: `calc(100vh - ${appBarHeight}px)`,
          }}
        >
          <div>{children || null}</div>
        </div>
        <div
          className={[classes.footer, visible ? classes.visible : ""]
            .join(" ")
            .trim()}
          style={{
            height: footerHeight,
          }}
        >
          <Typography
            component="span"
            color="textSecondary"
            className={classes.footerContent}
          >
            &copy; {new Date().getFullYear()} {window.location.host}
          </Typography>
        </div>
      </>
    );
  });
